import React from 'react';
import PropTypes from 'prop-types';
import Tag from '../Tag';
import Button from '../Button';
import DeleteIcon from '../Icons/DeleteIcon';
import { formatDate } from '../Utils/dateHelper';
import { FilterTypes } from './Components';

const SelectedFilters = ({ filters, onClean, onRemoveFilter }) => {
  const keyFilters = Object.keys(filters);

  return (
    <div className="filter__selezionati">
      <Button
        className="filter__cleanAll"
        floating
        onClick={onClean}
        primary
      >
        <DeleteIcon />
      </Button>
      {keyFilters.map((key) => filters[key].map((item) => {
        let value = item.displayValue || item.valore;
        if (item.filterType === FilterTypes.DATERANGE) {
          value = Object.keys(value).map((x) => {
            const timestamp = Date.parse(value[x]);
            if (isNaN(timestamp) === false) {
              const newDate = new Date(value[x]);
              return formatDate(newDate.getDate(), newDate.getMonth() + 1, newDate.getFullYear(), '/');
            }
            return value[x];
          });
          value = ` da ${value[0]} a ${value[1]}`;
        } else if (item.filterType === FilterTypes.RANGE) {
          value = ` da ${value.from} a ${value.to}`;
        }

        return (
          <Tag
            className="filter__filterSelezionato"
            key={`${item}_${value}`}
            onClose={() => onRemoveFilter(item)}
          >
            <b>{item.description || item.name}</b>
            {': '}
            {item.displayValue || value}
          </Tag>
        );
      }))}
    </div>
  );
};

SelectedFilters.propTypes = {
  /** Lista dei filtri applicati */
  filters: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /** Callback invocata al click sul pulsante che rimuove tutti i filtri applicati */
  onClean: PropTypes.func.isRequired,
  /** Callback invocata al click sul pulsante che rimuove un singolo filtro applicato */
  onRemoveFilter: PropTypes.func.isRequired,
};

SelectedFilters.defaultProps = {
  filters: {},
};

export default SelectedFilters;
